import React from 'react';

const DangerIcon = ({ color = '#DB3952', width = 14, height = 12 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 14 12" fill="none">
      <path
        d="M1.97878 12H12.0188C13.0454 12 13.6854 10.8866 13.1721 9.99996L8.15211 1.32662C7.63878 0.439954 6.35878 0.439954 5.84545 1.32662L0.825445 9.99996C0.312112 10.8866 0.952112 12 1.97878 12ZM6.99878 7.33329C6.63211 7.33329 6.33211 7.03329 6.33211 6.66662V5.33329C6.33211 4.96662 6.63211 4.66662 6.99878 4.66662C7.36545 4.66662 7.66545 4.96662 7.66545 5.33329V6.66662C7.66545 7.03329 7.36545 7.33329 6.99878 7.33329ZM7.66545 9.99996H6.33211V8.66662H7.66545V9.99996Z"
        fill={color}
      />
    </svg>
  );
};

export default DangerIcon;
